// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__QT-Yi","navbar":"Navbar_navbar__PQXVW","menuItemContainer":"Navbar_menuItemContainer__lPQIv","arrowIcon":"Navbar_arrowIcon__521WB"};